import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { from, switchMap } from 'rxjs';
import { environment } from '../../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const msalService = inject(MsalService);
  const isApiRequest = req.url.includes(environment.apiUrl);

  if (!isApiRequest) {
    return next(req);
  }

  const account =
    msalService.instance.getActiveAccount() ??
    msalService.instance.getAllAccounts()[0];

  if (!account) {
    const requestWithoutToken = req.clone({
      withCredentials: true
    });

    return next(requestWithoutToken);
  }

  if (req.headers.has('Authorization')) {
    const requestWithCredentials = req.clone({
      withCredentials: true
    });

    return next(requestWithCredentials);
  }

  return from(
    msalService.instance.acquireTokenSilent({
      account,
      scopes: [environment.azureAd.apiScope]
    })
  ).pipe(
    switchMap((tokenResult) => {
      const requestWithToken = req.clone({
        withCredentials: true,
        setHeaders: {
          Authorization: `Bearer ${tokenResult.accessToken}`
        }
      });

      return next(requestWithToken);
    })
  );
};